export const contractDeploymentTx = "0x268a2cb8926e70541a093bccc20574fac860f5c43740056ed541e758a7add401";

export const contractDeploymentTxLink = `https://mumbai.polygonscan.com/tx/${contractDeploymentTx}`;

export const detweetAddress = "0x5cD2aCd5778b4f83D0673C2416C7e4B423685601";